<template>
  <div style="min-height: 100%">
  <div v-if="cannotSaveError" class="catch-unfocus" @click="cannotSaveError = false"></div>
    <inner-header></inner-header>
    <div class="main-contant">
      <div class="container">
        <div class="frame-box" :class="{active: editExperiment}">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-6 experiment-text" :class="{error: cannotSaveError && isLoggedIn}">
              <h1 class="experiment-link f black" @click="toggleEditExperiment()">{{experimentName}}</h1>
              <div  class="field-holder">
                <input
                  v-if="editExperiment"
                  v-focus
                  type="text"
                  class="form-control"
                  v-model="editedName"
                  @keyup.enter="changeName(editedName); toggleEditExperiment()"
                  @focusout="cancelEditExperimentNameOnBlur">
                <a href="#" ref="ok-icon" class="ok-icon" @click="changeName(editedName); toggleEditExperiment()" @mousedown="changeName(editedName); toggleEditExperiment()" ><img src="../../assets/ic_tick.png"></a>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-6" style="padding-left: 0" >
              <div class="btn-group dropdown save pull-right tooltip-holder">
                <option-dropdown></option-dropdown>
                <div class="section-divider">&nbsp;</div>
                <button type="button" class="button lg1 hoverable border pull-right" :class="{save: $store.state.experimentSaved}" @click="saveExperiment()">
                  <div class="anim"></div><i class="fa fa-check"></i><span v-if="!($store.state.experimentSaved)"> Save</span> Experiment<span v-if="$store.state.experimentSaved"> Saved</span></button>
                <div v-if="cannotSaveError" id="cannot-save-tooltip" class="tooltip error-tooltip" >
                  <a class="canceltooltip" href="#" @click="cannotSaveError = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                  <p v-if="!(this.$store.state.isLoggedIn)">In order to save your experiment, you must <a class="blue" href="#" @click="$store.commit('LOGIN_REQUESTED')">Sign in</a> or <a class="blue" href="#" @click="$store.commit('LOGIN_REQUESTED')">Sign up</a></p>
                  <p v-else-if="!(this.$store.state.experimentName)">You need to name your experiment before you can save it!</p>
                </div>
                <div class="section-divider">&nbsp;</div>
                <button type="button" class="button hoverable border pull-right" style="padding: 0 8px" @click="downloadExperiment()">Download Report</button>
<!-- temp   <button type="button" @click="logVars()">Log Variables</button> -->
              </div>
            </div>
          </div>
        </div>
        <result></result>
      </div>
    </div>
    <div class="progress-popup" style="display: none">
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import AppFooter from '../appFooter.vue'
import InnerHeader from '../innerHeader.vue'
import OptionDropdown from './optionDropdown.vue'
import Result from './result.vue'
import textMixins from '../../mixins/textMixins'
import routeGlobals from '../../mixins/routeGlobals'
import _ from 'lodash'
import htmlTemplate from '../../assets/downloadTemplate.htm'
import {RunStates} from '../../store/runStates'
import treeService from '../../texts/treeService'
import {summarizeKeys} from '../../texts'
import Spinner from '../spinner'
import $ from 'jquery'
import {versesInKey} from '../../mixins/book_to_chapter_and_verse_counts'

import downloadFunctionMixins from '../../mixins/downloadFunctionMixins'
// the above contains many functions called below by getDownloadHtml(), as well as their "dependencies"

function isExperimentUnsaved () {
  return true
}
function beforeUnloadHandler (event) {
  if (isExperimentUnsaved()) {
    event.preventDefault()
    event.returnValue = 'Unsaved changes'
    return 'Unsaved changes'
  }
}

export default {
  components: {
    Result,
    OptionDropdown,
    InnerHeader,
    AppFooter,
    Spinner
  },
  name: 'Experiment',
  mixins: [textMixins, routeGlobals, downloadFunctionMixins],
  data () {
    return {
      experimentNonNameStatic: 'Experiment (Not Named)',
      editedName: null,
      editExperiment: false,
      experimentSaved: false,
      savedData: [],
      cannotSaveError: false,
      // from here on, items were added to enable download
      errorObjects: [],
      testSetResults: [],
      chunkResults: null,
      primaryKey: { name: 'Importance', defaultOrder: true },
      secondaryKey: { name: 'not yet', defaultOrder: true },
      tooFewVersesErrorText: ''
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.state.isLoggedIn
    },
    experimentName: function () {
      if (this.$store.state.experimentName) return this.$store.state.experimentName
      return this.experimentNonNameStatic
    },
    preventSave: function () {
      return (!(this.$store.state.isLoggedIn) || !(this.$store.state.experimentName)) && !(this.$store.state.experimentSaved)
    },
    stateDataCopy: function () {
      return JSON.parse(JSON.stringify({'classes': this.classes, 'testText': this.testText}))
    },
    savedDataCopy: function () {
      return JSON.parse(JSON.stringify(this.savedData))
    },
    changedSinceSave: function () {
      return !_.isEqual(this.savedDataCopy, this.stateDataCopy)
    },
    latestFeatures: function () {
      return this.$store.state.features // needed for strongestTTestOfClasses() (now in downloadFunctionMixins)
    }
  },
  methods: {
    toggleEditExperiment () {
      this.editExperiment = !(this.editExperiment)
      this.cannotSaveError = false
    },
    changeName (newName) {
      this.$store.commit('SET_EXPERIMENT_NAME', newName)
    },
    deriveNameFromData () {
      let name = ''
      if (this.testText) {
        name += this.testText.displayName
      }
      let classlist = []
      this.classes.forEach((textClass, index) => {
        classlist.push(textClass.displayName)
      })
      if (classlist.length > 0) {
        if (name !== '') {
          name += ' vs. '
        }
        name += classlist.join(' and ')
      }
      if (name === '') {
        name = 'No test text or classes'
      }
      return name
    },
    getDataToSave () {
      // return { 'classes': this.classes, 'testText': this.testText }
      return JSON.parse(JSON.stringify(this.stateDataCopy))
    },
    saveExperiment () {
      console.log('saveExperiment() called')
      if (!(this.preventSave)) {
        this.cannotSaveError = false
        console.log('about to try to save')
        this.$store.commit('SAVE_EXPERIMENT')
      } else if (!(this.$store.state.experimentSaved)) {
        this.cannotSaveError = true
      }
      /* let recordName = this.experimentName
      if (recordName === this.experimentNonNameStatic) {
        recordName = this.deriveNameFromData()
      }
      let savedExperiments = JSON.parse(window.localStorage.getItem('savedExperiments'))
      if (savedExperiments === null) { savedExperiments = { 'names': [] } } // because then we're about to start using it
      if (savedExperiments.names.indexOf(recordName) > -1) {
        // should prompt user here, but for now...
        while (savedExperiments.names.indexOf(recordName) > -1) {
          recordName += '*'
        }
      }
      savedExperiments.names.push(recordName)
      let recordData = this.getDataToSave()
      recordData['dateSaved'] = new Date()
      savedExperiments[recordName] = recordData
      window.localStorage.setItem('savedExperiments', JSON.stringify(savedExperiments))
      console.log(JSON.parse(window.localStorage.getItem('savedExperiments')))
      this.savedData = JSON.parse(JSON.stringify(this.stateDataCopy))
      this.experimentSaved = true */
    },
    logVars () {
      console.log('this.stateDataCopy:')
      console.log(this.stateDataCopy)
      console.log('this.savedDataCopy:')
      console.log(this.savedDataCopy)
      console.log('this.changedSinceSave:')
      console.log(this.changedSinceSave)
      console.log('_.isEqual(this.savedDataCopy, this.stateDataCopy)')
      console.log(_.isEqual(this.savedDataCopy, this.stateDataCopy))
    },
    cancelEditExperimentNameOnBlur (event) {
      if (event.relatedTarget === this.$refs['ok-icon']) {
        return
      }
      this.editExperiment = false
      this.editedName = this.experimentName
    },
    downloadExperiment () {
      if (this.cvState !== RunStates.COMPLETE) { console.log('No results to download!'); return }
      var text
      // var element
      let fileTypeName = 'html'
      if (fileTypeName === 'html') {
        $('.progress-popup').show()
        $('.vue-simple-progress-bar').css('width', '0%')
        setTimeout(() => {
          text = this.getDownloadHtml()
          let filename = 'TiberiasResults' + Math.floor(Math.random() * 100000000) + '.html'
          this.save(filename, text)
          // THE BELOW METHOD HAS A FILE SIZE LIMIT (HENCE THE CHANGE TO THE ABOVE):
          // console.log('text.length:')
          // console.log(text.length)
          // element = document.createElement('a')
          // element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
          // element.setAttribute('download', filename)
          // element.style.display = 'none'
          // document.body.appendChild(element)
          // element.click()
          // document.body.removeChild(element)
        }, 1)
      }
    },
    save: function (filename, data) {
      var blob = new Blob([data], {type: 'text/plain;charset=utf-8'})
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        var elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = filename
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
      }
    },
    strongestInfluence: function () { // copied verbatim from computed property in advancedInfoPopup.vue
      let strongest = 0.0
      this.chunkResults.featureList.forEach(feature => {
        if (Math.abs(feature.influence) > strongest) { strongest = Math.abs(feature.influence) }
      })
      // console.log('strongest influence:')
      // console.log(strongest)
      return strongest
    },
    strongestTTestOfText: function () { // copied verbatim from computed property in advancedInfoPopup.vue
      let strongest = 0.0
      this.chunkResults.featureList.forEach(feature => {
        if (Math.abs(feature.tTest) > strongest) { strongest = Math.abs(feature.tTest) }
      })
      // console.log('strongest tTest:')
      // console.log(strongest)
      return strongest
    },
    updateErrorData () { // copied verbatim from outliersPopup.vue
      const errorData = this.$store.state.crossValidationResults.mapTextKeyToFractionOfErrors
      if (!errorData) {
        return
      }
      const sortedKeys = treeService.treeSort(Object.keys(errorData))
      this.errorObjects = sortedKeys.map(key => ({
        key,
        name: summarizeKeys([key]),
        percentage: Math.round(errorData[key] * 100)
      }))
    },
    getSigOutOfTen (aspect, denominator) { // adapted from getSigTest() in editFeaturesPopup.vue and advancedInfoPopup.vue
      let sigOutOfTen = Math.round(Math.abs(aspect) / denominator * 10)
      return sigOutOfTen
    },
    getDownloadHtml () {
      let processedHtml = htmlTemplate.replace(/<!--<.*>-->/g, '') // remove MY explanatory comments
      processedHtml = this.replaceByLabel(processedHtml, 'EXPERIMENT NAME', this.$store.state.experimentName ? this.$store.state.experimentName : this.experimentName)
      processedHtml = this.replaceUsingCondition(processedHtml, 'TEXT CLASSIFICATION EXISTS', this.classifyState === RunStates.COMPLETE && this.extractFeaturesState === RunStates.COMPLETE)
      let colors = ['primary', 'warning', 'success']
      let classReplacements = this.classes.map((c, i) => {
        return {
          labelReplacements: [{label: 'CLASS NAME', replacement: c.displayName}],
          rawReplacements: [{
            original: 'list-group-item-primary', replacement: 'list-group-item-' + colors[i % colors.length]
          }]
        }
      })
      processedHtml = this.replaceWithList(processedHtml, 'CLASSES', classReplacements)
      if (this.classifyState === RunStates.COMPLETE && this.extractFeaturesState === RunStates.COMPLETE) {
        processedHtml = this.replaceByLabel(processedHtml, 'TEST TEXT NAME', this.testText.displayName)
      }
      processedHtml = this.replaceByLabel(processedHtml, 'ACCURACY', this.cv)
      const verseCounts = this.classes.map(classData => {
        let verseCount = 0
        for (const key of classData.keys) {
          if (/Pasuk \d*$/.test(key)) {
            verseCount += 1
          } else {
            verseCount += versesInKey(key)
          }
        }
        return verseCount
      })
      let tooFewVerses = verseCounts.some(count => count < 200)
      processedHtml = this.replaceUsingCondition(processedHtml, 'TOO FEW VERSES', tooFewVerses)
      if (tooFewVerses) {
        let tooSmallClasses = this.classes.filter((classData, index) => { return verseCounts[index] < 200 })
        this.tooFewVersesErrorText = ' in ' + tooSmallClasses.map(classData => {
          return classData.name ? classData.name : 'Class ' + (this.classes.map(classData => classData.id).indexOf(classData.id) + 1)
        }).join(', ')
        if (tooSmallClasses.length > 1) this.tooFewVersesErrorText = this.tooFewVersesErrorText.replace(/,([^,]*)$/, ' and $1')
        processedHtml = this.replaceByLabel(processedHtml, 'ERROR TEXT', this.tooFewVersesErrorText)
      }
      this.updateErrorData()
      let outlierReplacements = this.errorObjects.map((o, i) => {
        return {
          labelReplacements: [
            {label: 'OUTLIER PERCENTAGE', replacement: o.percentage},
            {label: 'OUTLIER NAME', replacement: o.name}],
          rawReplacements: []
        }
      })
      processedHtml = this.replaceWithList(processedHtml, 'OUTLIERS', outlierReplacements)
      let topFeatureClassReplacements = this.classes.map((c, i) => {
        return {
          labelReplacements: [{label: 'TOP FEATURE CLASSFUL NAME', replacement: c.displayName}],
          rawReplacements: [{
            original: 'CLASS ZERO', replacement: 'CLASS ' + i
          }]
        }
      })
      processedHtml = this.replaceWithList(processedHtml, 'CLASSFULS OF TOP FEATURES', topFeatureClassReplacements)
      var topFeatureReplacements
      this.classes.forEach((c, index) => {
        topFeatureReplacements = this.bestFeatures['class' + index].filter((f, i) => i < 3 || (i < 5 && f.tTest > 2)).map(f => {
          return {
            labelReplacements: [{label: 'TOP FEATURE NAME', replacement: this.prettyPrint(f.featureName)}],
            rawReplacements: []
          }
        })
        processedHtml = this.replaceWithList(processedHtml, 'TOP FEATURES OF CLASS ' + index, topFeatureReplacements)
      })
      const featureSetKeys = ['dicta token', 'words', 'morphology', 'syntaxClauseTypes', 'lexemes']
      const featureSetTitles = ['Disambiguated Words', 'Words', 'Morphology', 'Syntax', 'Lexemes']
      let featureSetKeyToTitle = {}
      for (var i = 0; i < featureSetKeys.length; i++) {
        featureSetKeyToTitle[featureSetKeys[i]] = featureSetTitles[i]
      } // of these last five lines, the first two are copied verbatim from editFeaturesPopup.vue
      processedHtml = this.replaceByLabel(processedHtml, 'ACTIVE FEATURE TYPE LIST',
        featureSetKeys.filter(k => this.$store.state.featureSettings[k].active)
          .map(k => featureSetKeyToTitle[k]).join(', '))
      let linksToClassesReplacements = this.classes.map((c, i) => {
        return {
          labelReplacements: [{label: 'LINK CLASS NAME', replacement: c.displayName}],
          rawReplacements: [{
            original: 'CLASS-ID-GOES-HERE', replacement: i + 1 // technically not the 'id', but it's just for linking
          }]
        }
      })
      processedHtml = this.replaceWithList(processedHtml, 'LINKS TO CLASSES', linksToClassesReplacements)
      let allFeatureClassReplacements = this.classes.map((c, i) => {
        return {
          labelReplacements: [{label: 'ALL FEATURE CLASSFUL NAME', replacement: c.displayName}],
          rawReplacements: [{
            original: 'CLASS-ID-GOES-HERE', replacement: i + 1 // technically not the 'id', but it's just for linking
          }, {
            original: 'OF CLASS ZERO', replacement: 'OF CLASS ' + i
          }, {
            original: 'list-group-item-primary', replacement: 'list-group-item-' + colors[i % colors.length]
          }]
        }
      })
      processedHtml = this.replaceWithList(processedHtml, 'CLASSFULS OF ALL FEATURES', allFeatureClassReplacements)
      /*
      setTimeout(() => {
        $('.vue-simple-progress-bar').css('width', '33%')
      }, 1)
      */
      var allFeatureReplacements
      let storeDataLookup = {}
      this.classes.forEach((c, cIndex) => {
        allFeatureReplacements = this.bestFeatures['class' + cIndex].map((f, fIndex) => {
          const storeData = this.$store.state.features[f.featureType].filter(sf => sf.featureName === f.featureName)[0]
          storeDataLookup['FEATURE ' + fIndex + ' OF CLASS ' + cIndex] = storeData
          return {
            labelReplacements: [
              {label: 'FEATURE NAME', replacement: this.prettyPrint(f.featureName)},
              {label: 'FEATURE SET', replacement: featureSetKeyToTitle[f.featureType]},
              {label: 'FEATURE OCCURRENCES', replacement: this.formatOccurrences(storeData.counts)},
              {
                label: 'FEATURE SIGNIFICANCE',
                replacement: this.getSigOutOfTen(storeData.bestTtest, this.strongestTTestOfClasses) + '/10'
              }
            ],
            rawReplacements: [{
              original: 'OF FEATURE ZERO FOR CLASS ZERO',
              replacement: 'OF FEATURE ' + fIndex + ' FOR CLASS ' + cIndex
            }]
          }
        })
        processedHtml = this.replaceWithList(processedHtml, 'ALL FEATURES OF CLASS ' + cIndex, allFeatureReplacements)
        var allAspectReplacements
        this.bestFeatures['class' + cIndex].forEach((f, fIndex) => {
          const storeData = storeDataLookup['FEATURE ' + fIndex + ' OF CLASS ' + cIndex]
          allAspectReplacements = this.classes.map((lookupClass, lcIndex) => {
            return {
              labelReplacements: [
                {label: 'CLASS FOR ASPECTS NAME', replacement: lookupClass.displayName},
                {label: 'FREQUENCY IN CLASS', replacement: (Math.round(storeData.averageFractions['class' + lcIndex] * 10000) / 100) + '%'},
                {label: 'OCCURRENCES IN CLASS', replacement: storeData.counts['class' + lcIndex]}
              ],
              rawReplacements: []
            }
          })
          processedHtml = this.replaceWithList(processedHtml, 'ASPECTS OF FEATURE ' + fIndex + ' FOR CLASS ' + cIndex, allAspectReplacements)
        })
      })
      /*
      setTimeout(() => {
        $('.vue-simple-progress-bar').css('width', '66%')
      }, 1)
      */
      if (this.classifyState === RunStates.COMPLETE && this.extractFeaturesState === RunStates.COMPLETE) {
        this.updateTestTextResults()
        // console.log('updated testSetResults:')
        // console.log(this.testSetResults)
        processedHtml = this.replaceUsingCondition(processedHtml, 'TWO OR MORE TEXT SECTIONS', this.testSetResults.length > 1)
        if (this.testSetResults.length > 1) {
          let linksToTextSectionsReplacements = this.testSetResults.map((result, i) => {
            return {
              labelReplacements: [{label: 'LINK TEXT SECTION NAME', replacement: this.getResultName(result)}],
              rawReplacements: [{
                original: 'TEXT-SECTION-ID-GOES-HERE', replacement: i + 1 // technically not an 'id'; but just for linking
              }]
            }
          })
          processedHtml = this.replaceWithList(processedHtml, 'LINKS TO TEXT SECTIONS', linksToTextSectionsReplacements)
        }
        let featureTextSectionReplacements = this.testSetResults.map((result, i) => {
          const confidenceText = result.confidence <= 0.75 ? 'Low' : (result.confidence >= 0.9 ? 'High' : 'Medium')
          return {
            labelReplacements: [{
              label: 'TEXT SECTION NAME', replacement: this.getResultName(result)
            }, {
              label: 'TEXT SECTION CHOSEN CLASS', replacement: result.classifiedAs
            }, {
              label: 'TEXT SECTION CONFIDENCE', replacement: confidenceText
            }],
            rawReplacements: [{
              original: 'TEXT-SECTION-ID-GOES-HERE', replacement: i + 1 // technically not an 'id'; but just for linking
            }, {
              original: 'OF TEXT SECTION ZERO', replacement: 'OF TEXT SECTION ' + i
            }, {
              original: 'OF FEATURE SECTION ZERO FOR TEXT SECTION ZERO',
              replacement: 'OF FEATURE SECTION ZERO FOR TEXT SECTION ' + i
            }, {
              original: 'list-group-item-primary', replacement: 'list-group-item-' + colors[i % colors.length]
            }]
          }
        })
        processedHtml = this.replaceWithList(processedHtml, 'TEXT SECTIONFULS OF FEATURES', featureTextSectionReplacements)
        let allFeatureSections
        this.testSetResults.forEach((testTextSectionResult, ttsIndex) => {
          this.chunkResults = testTextSectionResult // for functions originally from advancedInfoPopup.vue
          let map = {} // copied from part of featureMap() in advancedInfoPopup.vue
          this.chunkResults.featureList.forEach((feature, index) => {
            if (feature.orderByClass in map) {
              map[feature.orderByClass].push(index)
            } else {
              map[feature.orderByClass] = [index]
            }
          })
          // console.log('"featureMap" for ttsIndex ' + ttsIndex + ':')
          // console.log(map)
          allFeatureSections = []
          Object.keys(map).forEach(classIndex => {
            this.categorizedFeatureSetsArray(map[classIndex]).forEach((sectionData, fSetIndex) => {
              allFeatureSections.push({sectionData: sectionData, fSetIndex: fSetIndex, classIndex: classIndex})
            })
          })
          // console.log('"allFeatureSections" for ttsIndex ' + ttsIndex + ':')
          // console.log(allFeatureSections)
          let featureSectionReplacements = allFeatureSections.map((sectionObj, sectionIndex) => {
            let title = this.getClassName(sectionObj.classIndex)
            title += ' ' + sectionObj.sectionData[0] + ' features'
            title += ' [' + sectionObj.sectionData[1].length + ']'
            return {
              labelReplacements: [{label: 'FEATURE SECTION TITLE', replacement: title}],
              rawReplacements: [{
                original: 'OF FEATURE SECTION ZERO FOR TEXT SECTION ' + ttsIndex,
                replacement: 'OF FEATURE SECTION ' + sectionIndex + ' FOR TEXT SECTION ' + ttsIndex
              }]
            }
          })
          processedHtml = this.replaceWithList(processedHtml, 'FEATURE SECTIONS OF TEXT SECTION ' + ttsIndex, featureSectionReplacements)
          storeDataLookup = {}
          allFeatureSections.forEach((sectionObj, sectionIndex) => { // note to self: confirm whether fSetIndex gets used!
            allFeatureReplacements = sectionObj.sectionData[1].map((f, fIndex) => {
              const frequencyData = this.frequencyMiniTable(this.chunkResults.featureList[f])
              const bestClassText = frequencyData[0].text.split(' ')
              return {
                labelReplacements: [
                  {label: 'TEXT FEATURE NAME', replacement: this.prettyPrint(this.chunkResults.featureList[f].name)},
                  {
                    label: 'FEATURE FREQUENCY IN TEXT',
                    replacement: (this.chunkResults.featureList[f].freqInDoc * 100).toFixed(2) + '%'
                  },
                  {label: 'NAME OF BEST CLASS OF TEXT FEATURE', replacement: bestClassText.slice(0, -1).join(' ')},
                  {label: 'FEATURE FREQUENCY IN BEST CLASS', replacement: bestClassText[bestClassText.length - 1]},
                  {
                    label: 'FEATURE OCCURRENCES IN BEST CLASS',
                    replacement: this.chunkResults.featureList[f].bestClassOccurrences
                  },
                  {label: 'FEATURE FREQUENCY IN OTHER CLASSES', replacement: frequencyData[1].text.split(' ')[1]},
                  {
                    label: 'FEATURE OCCURRENCES IN OTHER CLASSES',
                    replacement: this.chunkResults.featureList[f].otherClassOccurrences
                  },
                  {
                    label: 'TEXT FEATURE IMPORTANCE',
                    replacement: this.getSigOutOfTen(this.chunkResults.featureList[f].influence, this.strongestInfluence()) + '/10'
                  },
                  {
                    label: 'TEXT FEATURE SIGNIFICANCE',
                    replacement: this.getSigOutOfTen(this.chunkResults.featureList[f].tTest, this.strongestTTestOfText()) + '/10'
                  }
                ],
                rawReplacements: []
              }
            })
            processedHtml = this.replaceWithList(processedHtml, 'FEATURES OF FEATURE SECTION ' + sectionIndex + ' FOR TEXT SECTION ' + ttsIndex, allFeatureReplacements)
          })
        })
      }
      /*
      setTimeout(() => {
        $('.vue-simple-progress-bar').css('width', '100%')
      }, 1)
      */
      setTimeout(() => {
        $('.progress-popup').hide()
      }, 1)
      return processedHtml
    },
    replaceByLabel (source, label, replacement) {
      let r = new RegExp('<!--###' + label + ' STARTS###-->' + '[\\s\\S]*?' + '<!--###' + label + ' ENDS###-->', 'g')
      return source.replace(r, replacement)
    },
    replaceUsingCondition (source, label, condition) {
      let r = new RegExp('<!--###FROM HERE SHOW ONLY IF ' + label + '###-->' + '([\\s\\S]*?)' + '<!--###UNTIL HERE SHOW ONLY IF ' + label + '###-->', 'g')
      return source.replace(r, condition ? '$1' : '')
    },
    replaceWithList (source, label, replacements) {
      let r = new RegExp('<!--###FROM HERE SHOW MULTIPLE ' + label + '###-->' + '([\\s\\S]*?)' + '<!--###UNTIL HERE SHOW MULTIPLE ' + label + '###-->')
      if (r.test(source)) {
        let template = source.match(r)[1]
        let processedReplacements = replacements.map(replacement => {
          let processedReplacement = template
          replacement.rawReplacements.forEach(rawR => {
            processedReplacement = processedReplacement.replace(new RegExp(rawR.original, 'g'), rawR.replacement)
          })
          replacement.labelReplacements.forEach(labelR => {
            processedReplacement = this.replaceByLabel(processedReplacement, labelR.label, labelR.replacement)
          })
          return processedReplacement
        }).join('')
        return source.replace(r, processedReplacements)
      } else { console.log('no "list" in source: ' + source); return source }
    }
  },
  mounted: function () {
    // Show Footer on page load
    document.getElementsByClassName('footer')[0].style.setProperty('display', 'block')
    // Call function from routeGlobals (Show popup on page load)
    this.initExperimentWindow()
    // Adding rest class to body
    document.body.className = 'rest'
    window.addEventListener('beforeunload', beforeUnloadHandler)
  },
  beforeRouteLeave (to, from, next) {
    if (isExperimentUnsaved()) {
      const answer = window.confirm('Do you really want to leave? You have unsaved changes!')
      if (!answer) {
        next(false)
        return
      }
    }
    window.removeEventListener('beforeunload', beforeUnloadHandler)
    next()
  }
}
</script>

<style scoped>
  .deactivate {
    background: gray !important
  }
  #cannot-save-tooltip {
    display: initial;
    z-index: 1000000;
  }
  .catch-unfocus {
    z-index: 999999;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgb(0,0,0,0.15)
  }
  .button span {
    font-size: 16px;
  }
  .progress-popup {
    position: absolute;
    top: 115px;
    left: 690px;
    z-index: 999999;
    height: 60px;
    padding: 10px;
    width: 60px;
    border: solid;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/experiment.vue